
import u from "umbrellajs"

import Modal from "app/modal/show-modal"
import YahooGemini_Conversions from "app/tracking/yahoo_gemini/conversions"
import Auth_state from "app/authentication/state"
import Auth_action from "app/authentication/action"
import Auth_callback_queue from "app/authentication/callback_queue"
import Goals from "app/tracking/goals/track"
import Notifier from "app/notifier/index"
import { Page } from "app/multi_device"


interface Selector {
  scope:                    string | HTMLElement
  contact_btns_container:   string
  whatsapp_call_btn:        string
  contact_call_btn:         string
}
interface InputSelector {
  scope?:                   string | HTMLElement
  contact_btns_container?:  string
  whatsapp_call_btn?:       string
  contact_call_btn?:        string
}
const DEFAULT_SELECTOR = {
  scope:                  ".cell-new-development-contact-request-box",
  contact_btns_container: ".cell-new-development-contact-request-box--contact-phone--buttons",
  whatsapp_call_btn:      ".cell-new-development-contact-request-box--contact-button--whatsapp",
  contact_call_btn:       ".cell-new-development-contact-request-box--contact-button--call",
}


const init = (selector?: InputSelector) => {
  const sele = Object.assign({}, DEFAULT_SELECTOR, selector)
  const $scope = u(sele.scope)
  const $contact_btns_container = $scope.find(sele.contact_btns_container)
  const $contact_call_btns = $scope.find(sele.contact_call_btn)
  const $whatsapp_call_btn = $scope.find(sele.whatsapp_call_btn)

  const message_no_login_no_contact_phone = $scope.data("message-no-login-no-contact-phone")

  $whatsapp_call_btn.on("click", (e) => {
    const $this = u(e.currentTarget as HTMLElement)

    e.preventDefault()

    if (Auth_state.isSignedOut()){
      Notifier.showWarning(message_no_login_no_contact_phone)
      Auth_action.showSignUpModal()

      const on_sign_in_event_listener = () => {
        window.location.href = $this.attr("href")
      }

      const slot_name = `cell-new-development-contact-request-box--contact-button--whatsapp__${(new Date()).getTime()}`
      Auth_callback_queue.add(on_sign_in_event_listener, slot_name)

      // # If not signed in in 5 mins, no autobutton reveal
      setTimeout(() => {
        Auth_callback_queue.remove(slot_name)
      }, 5 * 60 * 1000)
      return
    }

    window.location.href = $this.attr("href")
  })

  $contact_call_btns.on("click", (e) => {
    e.preventDefault()

    YahooGemini_Conversions.SendPhoneEnquiry.track()

    if (Auth_state.isSignedOut()){
      Notifier.showWarning(message_no_login_no_contact_phone)
      Auth_action.showSignUpModal()

      const on_sign_in_event_listener = () => {
        if (Page.isForDesktop()){
          e.preventDefault()

          $contact_btns_container.addClass("show_number")
        }else{
          Modal.hideTopModal()
          Modal.showModalWithContent(
            $scope.find("#modal-cell-new-development-contact-request-box--contact-phone--buttons").html(),
            {customContent: true, hideOverflowMobileFixClass: true}
          )
        }

        Goals.ListingContactSuccessByPhone.track(
          Goals.ListingContactSuccessByPhone.PropertyTypeLabels.OVERSEAS,
        )
      }

      const slot_name = `cell-new-development-contact-request-box__show_contact_phone__${(new Date()).getTime()}`
      Auth_callback_queue.add(on_sign_in_event_listener, slot_name)

      // # If not signed in in 5 mins, no autobutton reveal
      setTimeout(() => {
        Auth_callback_queue.remove(slot_name)
      }, 5 * 60 * 1000)
      return
    }

    if (Page.isForDesktop()){
      e.preventDefault()

      $contact_btns_container.addClass("show_number")
    }else{
      Modal.hideTopModal()
      Modal.showModalWithContent(
        $scope.find("#modal-cell-new-development-contact-request-box--contact-phone--buttons").html(),
        {customContent: true, hideOverflowMobileFixClass: true}
      )
    }

    Goals.ListingContactSuccessByPhone.track(
      Goals.ListingContactSuccessByPhone.PropertyTypeLabels.OVERSEAS,
    )
  })
}

export default {init}
